// extracted by mini-css-extract-plugin
export default {"selectInputSize":"select-module__selectInputSize___DBKI0"};